import {
  ME,
  LOGOUT,
  SELECT_LOCALE,
  GET_ACCESS_CODE,
  UPDATE_USERNAME,
  UPDATE_ACCOUNT_PIN
} from 'shared/actions/types';

import UserService from 'shared/services/UserService';
// import { Braze, onBrazeInit } from 'shared/services/Braze';
// import { inAppMessageHandler } from 'app/services/Braze';

let userService = new UserService();

export const me = () => dispatch => {
  return userService.me()
    .then(user => {
      if (user) {
        // Braze.changeUser(user.id);
        // Braze.openSession();
        // onBrazeInit(inAppMessageHandler);

        // let u = Braze.getUser();
        // u.setEmail(user.email);
        // u.setAvatarImageUrl(user.avatar_url);
        // u.setCustomUserAttribute('Portal.Account', user.account_id);
        // u.setCustomUserAttribute('User.CreatedAt', user.created_at);
        // u.setCustomUserAttribute('Customer.CreatedAt', user.campaign_info['customer_created_at']);
        // u.setCustomUserAttribute('Customer.PhotoCount', user.campaign_info['photo_count']);
        // u.setCustomUserAttribute('BranchLink.LinkType', user.campaign_info['link_type']);
        // u.setCustomUserAttribute('BranchLink.BranchLinkUrl', user.campaign_info['branchlink_url']);
        // u.setCustomUserAttribute('Purchase.PurchaseId', user.campaign_info['purchase_id']);
        // u.setCustomUserAttribute('Customer.JobId', user.campaign_info['job_id']);
        // u.setCustomUserAttribute('Customer.EmailSubscribed', user.campaign_info['email_subscribe']);
        // u.setCustomUserAttribute('Job.EventId', user.campaign_info['event_id']);
        // u.setCustomUserAttribute('User.Locale', user.campaign_info['locale']);
        // u.setFirstName(user.campaign_info['first_name']);
        // u.setLastName(user.campaign_info['last_name']);

        // const jobName = user.campaign_info['job_name'];
        // if (jobName) {
        //   u.setCustomUserAttribute('Job.JobName', user.campaign_info['job_name']);
        // }

        dispatch({
          type: SELECT_LOCALE,
          payload: user?.locale
        })
      }
      dispatch({
        type: ME,
        payload: user
      });

      return Promise.resolve(user);
    });
}

export const logout = () => dispatch => {
  return userService.logout()
    .then(() => {
      dispatch({
        type: LOGOUT
      });

      return Promise.resolve();
    });
}

export const getAccessCode = () => async dispatch => {
  let accessCode = await userService.getAccessCode();
  dispatch({
    type: GET_ACCESS_CODE,
    payload: accessCode
  });

  return Promise.resolve();
}

export const updateName = (name) => dispatch => {
  dispatch({
    type: UPDATE_USERNAME,
    payload: name
  });
}

export const updatePin = (pin) => dispatch => {
  dispatch({
    type: UPDATE_ACCOUNT_PIN,
    payload: pin
  });
}
